import { IconContent } from '@icons';

export const eyeOpened: IconContent = {
    sm: '<path d="M8 12c-4 0-6-4-6-4s2-4 6-4 6 4 6 4-2 4-6 4ZM3.207 7.93a7.438 7.438 0 0 0-.046.07l.046.07c.223.335.557.78 1 1.223C5.098 10.183 6.36 11 8 11s2.902-.816 3.793-1.707A8.11 8.11 0 0 0 12.839 8a8.128 8.128 0 0 0-1.046-1.293C10.902 5.817 9.64 5 8 5s-2.902.816-3.793 1.707a8.117 8.117 0 0 0-1 1.223ZM8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" />',
};
